import { render, staticRenderFns } from "./Library.view.vue?vue&type=template&id=2888ca9a&scoped=true&"
import script from "./Library.view.vue?vue&type=script&lang=ts&"
export * from "./Library.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2888ca9a",
  null
  
)

export default component.exports